import {FC} from 'react';
import {Box, Stack} from '@chakra-ui/react';
import {useT} from '@kcast-fe/core';
import {Control, Controller} from 'react-hook-form';
import {IPersonalizationForm} from 'core';
import {Input} from '@kcast-fe/ui-kit';

interface IProps {
  control: Control<IPersonalizationForm>;
}

export const AssistantFieldsForm: FC<IProps> = ({control}) => {
  const {t} = useT();

  return (
    <Stack gap={'20px'}>
      <Controller
        control={control}
        name={`assistant_name`}
        rules={{required: true}}
        render={({field: {onChange, value}}) => (
          <Stack gap={'8px'}>
            <Box p={'0 4px'}>{t('fields.agent_name')}</Box>
            <Input
              size={'lg'}
              value={value}
              onChange={(e) => {
                onChange(e.target.value);
              }}
            />
          </Stack>
        )}
      />
    </Stack>
  );
};
